import { __extends } from "tslib";
import { deserializeAws_restXmlGetBucketReplicationCommand, serializeAws_restXmlGetBucketReplicationCommand } from "../protocols/Aws_restXml";
import { getBucketEndpointPlugin } from "@aws-sdk/middleware-bucket-endpoint";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var GetBucketReplicationCommand = /** @class */ (function (_super) {
    __extends(GetBucketReplicationCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function GetBucketReplicationCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    GetBucketReplicationCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use(getBucketEndpointPlugin(configuration));
        var stack = clientStack.concat(this.middlewareStack);
        var handlerExecutionContext = {
            logger: {}
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    GetBucketReplicationCommand.prototype.serialize = function (input, context) {
        return serializeAws_restXmlGetBucketReplicationCommand(input, context);
    };
    GetBucketReplicationCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_restXmlGetBucketReplicationCommand(output, context);
    };
    return GetBucketReplicationCommand;
}($Command));
export { GetBucketReplicationCommand };
//# sourceMappingURL=GetBucketReplicationCommand.js.map